module.exports = __webpack_public_path__ + "img/4.e82d6d0c.png";